const dataTutoEnglish = [
  {
    id: 1,
    nomTuto: 'How to install a worktop in your kitchen',
    slug: 'how-to-install-a-worktop-in-your-kitchen',
    intro: 'Your brand new kitchen need a worktop ? here we go !',
    imgIntro:
      'https://images.unsplash.com/photo-1600585152220-90363fe7e115?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    difficulty: '⚒️⚒️⚒️',
    time: '2h',
    category: 'interiors',
    steps: [
      {
        etape: 'Remove all drawers from the cabinet',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/pre-etape.png',
      },
      {
        etape: 'Measure the total length of the work surface.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/etape-1.png',
      },
      {
        etape:
          'Transfer this measurement to the back of the plane by drawing a straight line with the pencil.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/etape1.2.png',
      },
      {
        etape:
          "Attach the mason's rule to the work surface with the clamps, it will guide the saw along the line to cut the work surface.",
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/etape-2.1.png',
      },
      {
        etape:
          'Saw inside the cut line of the scrap, sand the edge of the work surface with 80 grit sandpaper and dust off the cut.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/etape-2.2.png',
      },
      {
        etape:
          'Brush the neoprene glue onto the edge of the worktop and onto the strip. When it is dry to the touch, adjust the strip on the edge.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/etape-3.1.png',
      },
      {
        etape:
          'Flatten the edges of the edgeband with a wood chisel or a cutter. Then sand the edges of the strip with 220-grit sandpaper.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/etape-3.2.png',
      },
      {
        etape:
          'Place the worktop on the cabinet and press it against the wall.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/etape-4.1.png',
      },
      {
        etape: 'Attach the cabinet from below and reassemble the drawers.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2019/04/etape-4.2.png',
      },
    ],
    materiaux: [
      {
        nom: 'Drilling and aiming machine',
        lien: 'https://www.manomano.fr/perceuse-1146',
        img: 'https://cdn.manomano.com/images/images_products/7666072/P/13575359_3.jpg',
        quantity: 1,
      },
      {
        nom: 'Circular saw',
        lien: 'https://www.manomano.fr/scie-circulaire-1202',
        img: 'https://cdn.manomano.com/images/images_products/5307819/P/14708994_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Sanding block',
        lien: 'https://www.manomano.fr/recherche/cale+a+poncer',
        img: 'https://cdn.manomano.com/3000-grains-cale-a-poncer-a-main-en-diamanteponge-abrasive-tampons-a-maint-en-polissage-pour-polissage-du-pierre-verre-carrelage-beton-granit-marbre-P-2384618-22162682_1.jpg',
        quantity: 1,
      },
      {
        nom: "Mason's rule",
        lien: 'https://www.manomano.fr/recherche/r%C3%A8gle+macon',
        img: 'https://cdn.manomano.com/regles-de-macon-aluminium-l-4-m-P-33733-37939218_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Rolling meter',
        lien: 'https://www.manomano.fr/metre-deroulant-500',
        img: 'https://cdn.manomano.com/metre-ruban-premium-grip-facom-5m-x-28mm-897a528pb-P-12-8962106_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Chisel',
        lien: 'https://www.manomano.fr/ciseau-a-bois-536',
        img: 'https://cdn.manomano.com/coffret-de-ciseaux-a-bois-5-pieces-6-10-15-20-25-mm-manche-bimatiere-stanley-2-16-888-P-6145579-24134543_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Clamps',
        lien: 'https://www.manomano.fr/serre-joint-513',
        img: 'https://cdn.manomano.com/workpro-jeu-de-serre-joint-metallique-a-liberation-rapide-4-pieces-largeur-de-serrage-300-mm-et-150-mm-force-de-serrage-maximale-de-272-kg-pour-travail-du-bois-des-metaux-et-diy-P-20412836-37819987_1.jpg',
        quantity: 2,
      },
      {
        nom: 'Screws',
        lien: 'https://www.manomano.fr/vis-592',
        img: 'https://cdn.manomano.com/vis-ttpc-25-mm-pour-plaque-de-pltre-placo-500-pices-diamtre-8mm-et-un-embout-inclus-P-13219133-24081046_1.jpg',
        quantity: 30,
      },
      {
        nom: 'WorkPlan',
        lien: 'https://www.manomano.fr/plan-de-travail-135',
        img: 'https://cdn.manomano.com/plan-de-travail-hetre-massif-lamelle-colle-aboute-2500-x-650-x-26-mm-fsc-100-P-10953158-25863163_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Neoprene glue',
        lien: 'https://www.manomano.fr/colle-neoprene-1127',
        img: 'https://cdn.manomano.com/sader-colle-contact-neoprene-multi-usages-gel-transparent-500-ml-P-4298710-35602165_1.jpg',
        quantity: 1,
      },
    ],
  },
  {
    id: 2,
    nomTuto: 'How to build a wood terrace',
    slug: 'how-to-build-a-wood-terrace',
    intro: 'Your concrete terrace is boring you ? try to build a wood one !',
    imgIntro:
      'https://images.unsplash.com/photo-1503003378590-66f89f543bc6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
    difficulty: '⚒️⚒️⚒️⚒️⚒️',
    time: '6h',
    category: 'exteriors',
    steps: [
      {
        etape: 'The joist is placed on concrete blocks.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/1_solivage-deja-pose-3-750x410.jpg',
      },
      {
        etape: 'The waterproofing strip is laid on all the joists.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/2_pose-bande-detancheite-3-750x410.jpg',
      },
      {
        etape: 'The boards are cut to size before being installed.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/3_pose_terrasse-15-750x410.jpg',
      },
      {
        etape:
          'The pre-drilling wedge is used as a guide to pre-drill the blades. The distance between the screw hole and the edge of the blade should be between 15 and 29 mm.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/4_pre-percage-750x410.jpg',
      },
      {
        etape:
          'The boards are fixed on the joists respecting the spacing between each.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/5_cales-4-750x410.jpg',
      },
      {
        etape: 'The shims allow a constant spacing between each blade.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/6_cales-7-750x410.jpg',
      },
      {
        etape:
          'The boards are all installed on one side of the deck before managing the junction with the other part.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/7_pose_terrasse-45-750x410.jpg',
      },
      {
        etape:
          "After drawing the cutting line, the edge of the boards is cut with a circular saw. The mason's rule is used as a guide.",
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/8_pose_terrasse-46b-750x410.jpg',
      },
      {
        etape:
          'The other blades are cut at the same angle. The spacing of 3 mm is respected.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/9_pose_terrasse-49-750x410.jpg',
      },
      {
        etape:
          'On the outside of the deck, we trace the cutting line with blue thread.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/10_pose_terrasse-55-750x410.jpg',
      },
      {
        etape: 'The edge of the blades is cut with a circular saw.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/11_pose_terrasse-57-750x410.jpg',
      },
      {
        etape: 'The cutting area is covered with a protective product.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2018/04/12_retraitement-des-coupes-750x410.jpg',
      },
    ],
    materiaux: [
      {
        nom: 'Drilling and aiming machine',
        lien: 'https://www.manomano.fr/perceuse-1146',
        img: 'https://cdn.manomano.com/images/images_products/7666072/P/13575359_3.jpg',
        quantity: 1,
      },
      {
        nom: 'Circular saw',
        lien: 'https://www.manomano.fr/scie-circulaire-1202',
        img: 'https://cdn.manomano.com/images/images_products/5307819/P/14708994_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Wood protection product',
        lien: 'https://www.manomano.fr/recherche/produit+protection+bois',
        img: 'https://cdn.manomano.com/impermeabilisant-hydrofuge-bois-exterieur-et-saturateur-permet-de-conserver-l-aspect-naturel-teck-pin-bois-exotique-chene-arcane-industries-liquide-transparent-075-l-jusqu-a-375m-P-191006-1372530_1.jpg',
        quantity: 1,
      },
      {
        nom: 'A roll of sealing tape',
        lien: 'https://www.manomano.fr/recherche/Un+rouleau+de+bande+d%E2%80%99%C3%A9tanch%C3%A9it%C3%A9',
        img: 'https://cdn.manomano.com/rouleaux-bande-detancheite-outil-de-calfeutragebande-de-baignoireauto-adhesif-ruban-caulkpour-cuisinesalle-de-baincoin-starlight4pcs-P-21609242-47674282_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Rolling meter',
        lien: 'https://www.manomano.fr/metre-deroulant-500',
        img: 'https://cdn.manomano.com/metre-ruban-premium-grip-facom-5m-x-28mm-897a528pb-P-12-8962106_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Screws',
        lien: 'https://www.manomano.fr/vis-592',
        img: 'https://cdn.manomano.com/vis-ttpc-25-mm-pour-plaque-de-pltre-placo-500-pices-diamtre-8mm-et-un-embout-inclus-P-13219133-24081046_1.jpg',
        quantity: 300,
      },
    ],
  },
  {
    id: 3,
    nomTuto: 'how to fix a leaky or blocked faucet',
    slug: 'how-to-fix-a-leaky-or-blocked-faucet',
    intro: 'Damn, my tap is leaking. Dont worry and fix it !',
    imgIntro:
      'https://images.unsplash.com/photo-1585486194265-f3eb6058c443?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
    difficulty: '⚒️',
    time: '30 min',
    category: 'plumbing',
    steps: [
      {
        etape:
          'Before you start, turn off the main water supply valve, then let the relevant valve run to drain the remaining water. We also recommend that you close the drain to prevent a screw or anything else from slipping in. Remove the blue or red sticker depending on the side of the leak, so you can unscrew the cover of the faucet handle. Then, with a wrench, loosen the nut on the faucet head. If it resists you, use a bit of degreaser. Finish unscrewing it by hand.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2017/08/5111_fuite_rob1-750x410.jpg',
      },
      {
        etape:
          'Carefully lift the gasket, also called a valve gasket, with a screwdriver. If this gasket is worn, it no longer seals the valve. Next, clean the surface of the valve head where the new gasket will fit. Finally, insert the new gasket into the housing, making sure it is secure.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2017/08/5113_fuite_rob4-750x410.jpg',
      },
      {
        etape:
          'Once the gasket is in place, check that the valve head is in the open position, then screw it back on, first by hand, then with the wrench. Be careful not to overtighten. For a better seal, you can put Teflon tape around it. Then, replace the handle of the faucet, and screw it on. Finally, replace the colored disc.',
        image:
          'https://www.maison-travaux.fr/wp-content/uploads/sites/8/2017/08/5112_fuite_rob3-750x410.jpg',
      },
    ],
    materiaux: [
      {
        nom: 'Wrench',
        lien: 'https://www.manomano.fr/recherche/cl%C3%A9+molette',
        img: 'https://cdn.manomano.com/jeu-de-3-cles-a-molette-P-261713-1151010_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Screwdriver',
        lien: 'https://www.manomano.fr/tournevis-plat-cruciforme-torx-de-precision-491',
        img: 'https://cdn.manomano.com/jeu-de-10-tournevis-protwist-facom-atj10-P-6145579-16779218_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Seals',
        lien: 'https://www.manomano.fr/tournevis-plat-cruciforme-torx-de-precision-491',
        img: 'https://cdn.manomano.com/images/C/cat_1206.jpg',
        quantity: 1,
      },
      {
        nom: 'Teflon tape',
        lien: 'https://www.manomano.fr/teflon-1595',
        img: 'https://cdn.manomano.com/rouleau-teflon-ptfe-standard-12mmx12m-epaisseur-01mm-P-362751-1031750_1.jpg',
        quantity: 1,
      },
    ],
  },
  {
    id: 4,
    nomTuto: 'how to lay tiles on the bathroom wall',
    slug: 'how-to-lay-tiles-on-the-bathroom-wall',
    intro: 'I want to change my tiles but how to do it ?',
    imgIntro:
      'https://images.unsplash.com/photo-1584346651592-3aacc3c99075?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
    difficulty: '⚒️⚒️⚒️⚒️',
    time: '4h',
    category: 'interiors',
    steps: [
      {
        etape:
          'Measure your tile height, and mark a point on the bathroom wall that is 20mm below that height. Then use your spirit level to draw a horizontal line, known as a “datum line”, at that height all the way around the room. The height is reduced by 20mm just in case there is a low point in the floor that needs covering.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/a04503f99a464874952fb5c23d45e61a?v=f51c797c&t=w700h461SmartCropdpr2',
      },
      {
        etape:
          'Get a long, straight piece of timber and mount it on the bathroom wall so its top edge lines up with your datum line. Then drive a screw through the middle of the timber into a wall stud. Now use a spirit level to check the timber is horizontal and screw the two ends into wall studs as well.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/66aff8d05eac44079ec6a223c8b506a6?v=ba21e683&t=w700h461SmartCropdpr2',
      },
      {
        etape:
          'Building regulations require the walls of your bathroom to have a waterproof lining installed. Once that lining is in place, you can start tiling. Check the information on the side of your packet of tile glue to make sure that it is safe to use with waterproofing.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/4de6fbfb093c479594a404fb900d519c?v=a2b90696&t=w700h461SmartCropdpr2',
      },
      {
        etape:
          'To work out the width of the last tile in a row, lay one tile in position on the timber shelf you have installed. Then move it down the shelf one tile-width at a time, plus the width of a spacer, until you reach the end of the row. If the final tile needs to be short, you can pre-trim one for each row before you start tiling.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/841c51f345bd4c5ab45b7464f942d878?v=57918a23&t=w700h461SmartCropdpr2',
      },
      {
        etape:
          'Pour some tile glue powder into a bucket with some water in it, then use a power drill with a mixing paddle to blend the mixture together. Keep mixing until the glue has the consistency of toothpaste. If you find that its too runny or dry, then balance it out with a little more powder or water.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/de34d5f2386546ab83ec961dc1a209bf?v=8eace65a&t=w700h461SmartCropdpr2',
      },
      {
        etape:
          'Spread some glue on the back of the first tile using the notched edge of your trowel. This makes trenches in the glue so the tile sticks better. Then place the base of the tile on the timber shelf and flatten it onto the wall. Clean off any excess glue and push plastic wedges under the bottom corners of the tiles. Repeat for every tile across the row, putting spacers between each tile as you go.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/2fe016f0cf594ba5beda92baebe20d97?v=84e9b50b&t=w700h461SmartCropdpr2',
      },
      {
        etape:
          'Once the first row of tiles has been laid, put a spirit level on top to check that they are horizontal. This is where the wedges are helpful. If any of the tiles need adjusting, simply shift the position of the wedges to lift or drop the tiles so they line up correctly.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/682d1f298919436ba904fc4dfdc29206?v=9527c6c9&t=w700h461SmartCropdpr2',
      },
      {
        etape:
          'Put enough glue on the wall to cover a couple of rows of tiles. Once again, use the notched side of your trowel to put trenches in the glue as you spread it. When you have spread the glue, work quickly to put your tiles in place before the glue starts to cure. Lay them one row at a time, using plastic spacers to keep the gaps between each tile the same. If you need to trim a tile before you lay it, leave that area free of glue and do that tile as part of the next step.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/3021263af2884e39a9fe0e41e6219598?v=00a35af4&t=w700h461SmartCropdpr2',
      },
      {
        etape:
          'When you need to trim a tile before you lay it, put the tile in place on the wall, mark your cutting points and use a tile cutter or angle grinder to trim the tile to size. Then put your tile in place again to check the cut is right, put some glue on the back and lay it in position.',
        image:
          'https://media.prod.bunnings.com.au/api/public/content/04aa4e02ea0c48c8bde4538a4fb49ad8?v=abbca0e3&t=w700h461SmartCropdpr2',
      },
    ],
    materiaux: [
      {
        nom: 'Angle grinder',
        lien: 'https://www.manomano.fr/recherche/meuleuse+angle',
        img: 'https://cdn.manomano.com/meuleuse-angulaire-bosch-1400w-gws-1400-125mm-P-5307819-24410259_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Bucket',
        lien: 'https://www.manomano.fr/recherche/seau',
        img: 'https://cdn.manomano.com/seau-de-macon-plastique-mondelin-P-9344565-31490059_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Drill',
        lien: 'https://www.manomano.fr/recherche/foret',
        img: 'https://cdn.manomano.com/lot-de-6-forets-a-visser-m3-m10-a-changement-rapide-hexagonal-forets-combines-fraises-fraises-fraises-fraises-en-acier-rapide-1-4-P-18152444-32753086_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Hammer',
        lien: 'https://www.manomano.fr/marteau-rivoir-1215',
        img: 'https://cdn.manomano.com/marteau-manche-graphite-facom-marteau-rivoir-200c40-40-P-3248867-6700920_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Mastic Glue',
        lien: 'https://www.manomano.fr/recherche/mastic',
        img: 'https://cdn.manomano.com/colle-mastic-mastiprene-cartouche-de-300-ml-P-12-6955_1.jpg',
        quantity: 1,
      },
    ],
  },
  {
    id: 5,
    nomTuto: 'How to disassemble a toilet',
    slug: 'how-to-disassemble-a-toilet',
    intro:
      'Your toilet is too low for your knees ? lets try to disassemble it !',
    imgIntro:
      'https://images.unsplash.com/photo-1581310152154-c7cc480bca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
    difficulty: '⚒️⚒️⚒️',
    time: '1h',
    category: 'plumbing',
    steps: [
      {
        etape: 'Turn off the water supply',
        image: 'https://www.maison.com/images/medias/000/034/000034622/600.jpg',
      },
      {
        etape: 'Flush the toilet to get rid of any remaining water in the tank',
        image:
          'https://www.initial.com/fr/blog/wp-content/uploads/2017/09/466035761-770x360-1.jpg',
      },
      {
        etape: 'Take a wrench and unscrew the nuts on the base of the toilet',
        image:
          'https://static.lceassets.com/thumbnails/cb/cb692f8485b082c2c50db8bda91a27cba2de81fa/cle-universelle-pour-abattant-wc-virax-square-1000x1000.jpg',
      },
      {
        etape: 'Gently lift the tank',
        image: '',
      },
      {
        etape: 'Loosen the floor bolts by removing their caps with a wrench',
        image:
          'https://blog-de-bricolage.fr/wp-content/uploads/2019/10/fuite-a-linterieur-du-reservoir-de-vos-wc-comment-la-reparer.jpg',
      },
      {
        etape: 'Then unscrew the nuts around the bolts',
        image: '',
      },
      {
        etape:
          'To break the seal between the silicone ring around the base of the toilet and the drain pipe, straddle the bowl. Gently move the bowl to one side, then to the other. Then set it aside.',
        image:
          'https://www.maisonentravaux.fr/wp-content/uploads/2020/03/comment-deposer-ancien-wc.jpg',
      },
      {
        etape: 'Using a wire brush, polish the flange',
        image: '',
      },
      {
        etape:
          'To prevent gas from invading your bathroom, plug the hole in the flange or drain pipe',
        image: '',
      },
      {
        etape: 'Then put a bucket upside down on the pipe.',
        image: '',
      },
    ],
    materiaux: [
      {
        nom: 'Wrench',
        lien: 'https://www.manomano.fr/cle-a-molette-1223',
        img: 'https://cdn.manomano.com/cle-a-molette-10-facom-reglage-rapide-lg255-ouv-38-mm-10110g-P-12-12946931_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Wire brush',
        lien: 'https://www.manomano.fr/recherche/brosse+metallique',
        img: 'https://cdn.manomano.com/lot-de-3-brosses-a-main-ergonomiques-wolfcraft-2138000-P-8942628-16634331_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Bucket',
        lien: 'https://www.manomano.fr/recherche/seau',
        img: 'https://cdn.manomano.com/seau-de-macon-plastique-mondelin-P-9344565-31490059_1.jpg',
        quantity: 1,
      },
      {
        nom: 'Brain opener',
        lien: 'https://www.manomano.fr/recherche/debouche+canalisation',
        img: 'https://cdn.manomano.com/arebos-tuyau-de-nettoyage-de-canalisations-25-m-160-bar-noir-P-514012-8918162_1.jpg',
        quantity: 1,
      },
    ],
  },
  {
    id: 6,
    nomTuto: 'how to paint a ceiling with a roller',
    slug: 'how-to-paint-a-ceiling-with-a-roller',
    intro:
      'you want to paint your ceiling without painting your face ? follow the guide.',
    imgIntro:
      'https://images.unsplash.com/photo-1562259949-e8e7689d7828?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1662&q=80',
    difficulty: '⚒️⚒️',
    time: '4h',
    category: 'decoration',
  },
  {
    id: 7,
    nomTuto: 'how to install bright ceiling spots',
    slug: 'how-to-install-bright-ceiling-spots',
    intro:
      'Are you tired of getting stuck in the carpet? Light up your rooms with this tutorial.',
    imgIntro:
      'https://seemyfriends.co.uk/wp-content/uploads/2019/04/Spot-led.jpg',
    difficulty: '⚒️⚒️⚒️',
    time: '3h',
    category: 'interiors',
  },
  {
    id: 8,
    nomTuto: 'replace your floor with carpet',
    slug: 'replace-your-floor-with-carpet',
    intro:
      'cold feet ? what better way to take care of your feet than with soft carpeting.',
    imgIntro:
      'https://images.unsplash.com/photo-1564444247765-a377a8bfd0b8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
    difficulty: '⚒️⚒️',
    time: '2h',
    category: 'interiors',
  },
  {
    id: 9,
    nomTuto: 'how to put up wallpaper with flowers',
    slug: 'how-to-put-up-wallpaper-with-flowers',
    intro:
      'nostalgic for vintage patterns ? follow this tutorial and give your walls a 80s style',
    imgIntro:
      'https://www.izoa.fr/15976-large_default/papier-peint-annee-70-arc-en-ciel-vintage.jpg',
    difficulty: '⚒️⚒️',
    time: '3h',
    category: 'decoration',
  },
];

export default dataTutoEnglish;
